/**
 * 股东管理
 */
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>股东管理</el-breadcrumb-item>
    </el-breadcrumb>
    <el-form :inline="true" class="user-search">
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-plus" v-if="$canManage()" @click="handleEdit()">添加股东</el-button>
      </el-form-item>
    </el-form>
    <!--列表-->
    <el-table size="small" :data="listData" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;">
      <el-table-column prop="name" label="股东姓名" width="150">
      </el-table-column>
      <el-table-column prop="status" label="状态" width="100">
        <template v-slot="scope">
          <span v-if="scope.row.status === 1">在用</span>
          <span v-if="scope.row.status === 0">已退出</span>
        </template>
      </el-table-column>
      <el-table-column prop="totalDividend" label="累计分红" width="150" :formatter="(row) => formatNullValue(row.totalDividend)">
      </el-table-column>
      <el-table-column align="center" label="操作" min-width="200">
        <template slot-scope="scope">
          <el-button size="mini" v-if="$canManage()" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
          <el-button size="mini" type="danger" v-if="$canManage()" @click="deleteShareHolder(scope.$index, scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 编辑界面 -->
    <el-dialog :title="title" :visible.sync="editFormVisible" width="30%">
      <el-form label-width="100px" :model="editForm" :rules="rules" ref="editForm">
        <el-form-item label="股东姓名" prop="name">
          <el-input size="small" v-model="editForm.name" auto-complete="off" placeholder="请输入股东姓名"></el-input>
        </el-form-item>
        <el-form-item label="状态" prop="status">
          <el-select size="small" v-model="editForm.status" placeholder="请选择状态">
            <el-option label="在用" :value="1"></el-option>
            <el-option label="已退出" :value="0"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeDialog">取消</el-button>
        <el-button size="small" type="primary" :loading="loading" @click="submitForm('editForm')">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { shareHolderList, shareHolderSave, shareHolderDelete } from '../../api/shareholderMG'
export default {
  data() {
    return {
      loading: false,
      editFormVisible: false,
      title: '添加',
      editForm: {
        shareholderId: '',
        name: '',
        status: 1
      },
      rules: {
        name: [{ required: true, message: '请输入股东姓名', trigger: 'blur' }],
        status: [{ required: true, message: '请选择状态', trigger: 'change' }]
      },
      listData: []
    }
  },
  created() {
    this.getdata()
  },
  methods: {
    getdata() {
      this.loading = true
      shareHolderList()
        .then(res => {
          this.loading = false
          if (res.code !== '200') {
            this.$message({ type: 'info', message: res.message })
          } else {
            this.listData = res.data
          }
        })
        .catch(() => {
          this.loading = false
          this.$message.error('股东列表加载失败，请稍后再试！')
        })
    },
    handleEdit(index, row) {
      this.editFormVisible = true
      if (row !== undefined) {
        this.title = '修改'
        this.editForm.shareholderId = row.shareholderId
        this.editForm.name = row.name
        this.editForm.status = row.status
      } else {
        this.title = '添加'
        this.editForm.shareholderId = ''
        this.editForm.name = ''
        this.editForm.status = 1
      }
    },
    submitForm(editData) {
      this.$refs[editData].validate(valid => {
        if (valid) {
          shareHolderSave(this.editForm)
            .then(res => {
              this.editFormVisible = false
              this.loading = false
              if (res.code === '200') {
                this.getdata()
                this.$message({ type: 'success', message: '保存成功！' })
              } else {
                this.$message({ type: 'info', message: res.message })
              }
            })
            .catch(() => {
              this.editFormVisible = false
              this.loading = false
              this.$message.error('保存失败，请稍后再试！')
            })
        } else {
          return false
        }
      })
    },
    deleteShareHolder(index, row) {
      this.$confirm('确定要删除该股东吗?', '信息', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          shareHolderDelete([row.shareholderId])
            .then(res => {
              if (res.code === '200') {
                this.$message({ type: 'success', message: '已删除!' })
                this.getdata()
              } else {
                this.$message({ type: 'info', message: res.message })
              }
            })
            .catch(() => {
              this.loading = false
              this.$message.error('删除失败，请稍后再试！')
            })
        })
        .catch(() => {
          this.$message({ type: 'info', message: '已取消删除' })
        })
    },
    closeDialog() {
      this.editFormVisible = false
    },
    formatNullValue(value) {
      return value === null || value === undefined ? '0.00' : value
    }
  }
}
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}
</style>



// WEBPACK FOOTER //
// src/views/shareholder/ShareHolder.vue